// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3AgXi","bigColWidth":"Table_bigColWidth__13xpe","biggerColWidth":"Table_biggerColWidth__3dj7F","row":"Table_row__2XGpi","col":"Table_col__oCg7J"};